import React, { useEffect } from 'react';
import Contents from 'components/Layout/Contents';

export default function NotFound() {
  const { location } = window;
  useEffect(() => {
    if (!location.pathname.startsWith('/admin/')) {
      window.location.href = `/Error/404`;
    }
  }, []);
  return (
    <Contents>
      <h1>Page Not Found</h1>
    </Contents>
  );
}
